import { Text as ChakraText } from '@chakra-ui/react'

export const Text = ChakraText
